<template>
	<section>
		<div>
			<span style="font-weight: bold;font-size: 1.17em;padding: 8px 0;display: block;">商家查询</span>
		</div>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="昵称/账号/手机号：">
					<el-input size="small" v-model="filters.keyword" placeholder="请输入昵称/账号/手机号" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" v-on:click="getBusinessList">查询</el-button>
					<el-button type="primary" size="small" v-on:click="handleExport">导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table
				:data="merchants"
				id="merchants"
				highlight-current-row
				:height="h"
				border
				v-loading="loading"
				@selection-change="selsChange"
				style="width: 100%;">
			<el-table-column type="index" width="60"></el-table-column>
			<el-table-column prop="nickname" label="账户昵称" min-width="320" ></el-table-column>
      <el-table-column prop="account" label="账号" width="160" ></el-table-column>
			<el-table-column prop="registered_print" label="注册时间" width="150" ></el-table-column>
			<el-table-column prop="balance" label="当前余额" width="130" sortable></el-table-column>
			<el-table-column prop="grand_total_purchase" label="购买总量" width="130" sortable></el-table-column>
			<el-table-column prop="grand_total_used" label="使用总量" width="130" sortable></el-table-column>
			<el-table-column label="操作" width="120" v-if="operation">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination layout="prev, pager, next, sizes, total"
					   @current-change="handleCurrentChange"
					   @size-change="handleSizeChange"
					   :page-size="rows" :total="total"
					   style="float:right;">
		</el-pagination>

		<!--编辑界面-->
		<el-dialog title="商家详情" :visible.sync="merchantFormVisible">
			<el-form :model="merchantForm" label-width="90px" ref="merchantForm">
				<el-row>
					<el-col :span="6">
						<el-form-item label="账户昵称：">
							<span>{{merchantForm.nickname}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="账号:">
							<span>{{merchantForm.account}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="绑定手机:">
							<span>{{merchantForm.phone}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="注册日期:">
							<span>{{merchantForm.registered_print}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="云豆余额：" prop="name">
							{{merchantForm.balance}}
							<span style="margin-left: 20px;margin-right: 10px;">云豆使用总量 </span>{{merchantForm.grand_total_used}}
							<span style="margin-left: 20px;margin-right: 10px;">云豆购买总量 </span>{{merchantForm.grand_total_purchase}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="4">
						<el-form-item label="所在地区：" prop="name">
							<el-input v-model="merchantForm.name" readonly auto-complete="off" disabled="disabled" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="街道地址：" prop="name">
							<el-input v-model="merchantForm.name" readonly auto-complete="off" disabled="disabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-row>
							<el-col :span="20">
								<h3 style="margin-top: 4px;">(云豆)使用详情列表</h3>
							</el-col>
							<el-col :span="4">
								<el-button size="mini" type="primary" v-on:click="handleUseExport">导出</el-button>
							</el-col>
						</el-row>

						<el-table
								:data="useList"
								id="useList"
								highlight-current-row
								:height="480"
								border
								v-loading="useLoading"
								@selection-change="selsChange"
								style="width: 100%;">
							<el-table-column prop="created_print" label="日期"></el-table-column>
							<el-table-column prop="num" label="使用数量" width="130"></el-table-column>
							<el-table-column prop="current_balance" label="使用后余额" width="130"></el-table-column>
							<el-table-column prop="current_total_used" label="使用后总使用量" width="130"></el-table-column>
						</el-table>
						<el-pagination layout="prev, pager, next, sizes, total"
									   @current-change="handleUseCurrentChange"
									   @size-change="handleUseSizeChange"
									   :page-size="useRows" :total="useTotal"
									   style="float:right;">
						</el-pagination>
					</el-col>
					<el-col :span="1">&nbsp;</el-col>
					<el-col :span="11">
						<el-row>
							<el-col :span="20">
								<h3 style="margin-top: 4px;">(云豆)购买详情列表</h3>
							</el-col>
							<el-col :span="4">
								<el-button size="mini" type="primary" v-on:click="handleBuyExport">导出</el-button>
							</el-col>
						</el-row>
						<el-table
								:data="buyList"
								id="buyList"
								highlight-current-row
								:height="480"
								border
								v-loading="buyLoading"
								@selection-change="selsChange"
								style="width: 100%;">
							<el-table-column prop="created_print" label="交易日期" min-width="140"></el-table-column>
							<el-table-column prop="num" label="购买数量" width="110"></el-table-column>
							<el-table-column prop="current_balance" label="购买后余额" width="110"></el-table-column>
							<el-table-column prop="order_id" label="交易编号" width="190"></el-table-column>
						</el-table>
						<el-pagination layout="prev, pager, next, sizes, total"
									   @current-change="handleBuyCurrentChange"
									   @size-change="handleBuySizeChange"
									   :page-size="buyRows" :total="buyTotal"
									   style="float:right;">
						</el-pagination>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
	</section>

</template>

<script>
	import util from '../../common/js/util'
	import XLSX from "xlsx";
	import FileSaver from "file-saver";
	//import NProgress from 'nprogress'

	export default {
		data() {
			return {
				filters: {
					keyword: '',
					id_alias: '',
					phone: ''
				},
				operation: true,
				h:0,
				merchants: [],
				total: 0,
				page: 1,
				rows:20,
				loading: false,
				buyList:[],
				buyTotal: 0,
				buyPage: 1,
				buyRows:10,
				buyLoading: false,
				useList:[],
				useTotal: 0,
				usePage: 1,
				useRows:10,
				useLoading: false,
				merchantFormVisible: false,//编辑界面是否显示
				merchantForm:{},
				merchant:{}
			}
		},
		beforeMount() {
			this.h = document.body.clientHeight - 64 - 200;
		},
		methods: {
			handleExport(){
				if(this.merchants.length==0) return ;
				/* 从表生成工作簿对象 */
				this.operation = false;
				let wb = XLSX.utils.table_to_book(document.querySelector("#merchants"),{display:true});
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
							//Blob 对象表示一个不可变、原始数据的类文件对象。
							//Blob 表示的不一定是JavaScript原生格式的数据。
							//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
							//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
							new Blob([wbout], { type: "application/octet-stream" }),
							//设置导出文件名称
							"商家数据.xlsx"
					);
					this.operation = true;
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleBuyExport(){
				if(this.buyList.length==0) return ;
				/* 从表生成工作簿对象 */
				let wb = XLSX.utils.table_to_book(document.querySelector("#buyList"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
							//Blob 对象表示一个不可变、原始数据的类文件对象。
							//Blob 表示的不一定是JavaScript原生格式的数据。
							//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
							//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
							new Blob([wbout], { type: "application/octet-stream" }),
							//设置导出文件名称
							"购买详情.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleUseExport(){
				if(this.useList.length==0) return ;
				/* 从表生成工作簿对象 */
				let wb = XLSX.utils.table_to_book(document.querySelector("#useList"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
							//Blob 对象表示一个不可变、原始数据的类文件对象。
							//Blob 表示的不一定是JavaScript原生格式的数据。
							//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
							//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
							new Blob([wbout], { type: "application/octet-stream" }),
							//设置导出文件名称
							"使用详情.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getBusinessList();
			},
			handleSizeChange(val){
				this.rows = val;
				this.getBusinessList();
			},
			//获取用户列表
			getBusinessList() {
				let para = {
					page: this.page-1,
					rows: this.rows,
					sort_prop: "user_id",
					sort_order: "desc",
					keyword: this.filters.keyword
				};
				this.listLoading = true;
				//NProgress.start();
				this.$Api.getBusinessList(para).then((res) => {
					this.total = res.total;
					this.merchants = res.rows;
					this.listLoading = false;
					//NProgress.done();
				})
				.catch(err => {
					this.listLoading = false;
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.merchantFormVisible = true;
				this.merchant = Object.assign({}, row);
				this.getBusinessInfo();
				this.getUseRecordList();
				this.getBuyRecordList();
			},
			getBusinessInfo(){
				let para = {
					account: this.merchant.account,
				};
				//NProgress.start();
				this.$Api.getBusinessInfo(para).then((res) => {
          console.log(res)
					this.merchantForm = res;
					//NProgress.done();
				})
				.catch(err => {
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getUseRecordList(){
				console.log(this.merchant)
				let para = {
					page: this.usePage-1,
					rows: this.useRows,
					user_id: this.merchant.user_id
				};
				this.useLoading = true;
				//NProgress.start();
				this.$Api.getUseRecordList(para).then((res) => {
					this.useTotal = res.total;
					this.useList = res.rows;
					this.useLoading = false;
					//NProgress.done();
				})
				.catch(err => {
					this.useLoading = false;
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			getBuyRecordList(){
				let para = {
					page: this.buyPage-1,
					rows: this.buyRows,
					user_id: this.merchant.user_id
				};
				this.buyLoading = true;
				//NProgress.start();
				this.$Api.getBuyRecordList(para).then((res) => {
					this.buyTotal = res.total;
					this.buyList = res.rows;
					this.buyLoading = false;
					//NProgress.done();
				})
				.catch(err => {
					this.buyLoading = false;
					this.$message({
						message: err,
						type: "error"
					});
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			handleBuyCurrentChange(val){
				this.buyPage = val;
				this.getBuyRecordList();
			},
			handleBuySizeChange(val){
				this.buyRows = val;
				this.getBuyRecordList();
			},
			handleUseCurrentChange(val){
				this.usePage = val;
				this.getUseRecordList();
			},
			handleUseSizeChange(val){
				this.useRows = val;
				this.getUseRecordList();
			}

		},
		mounted() {
			this.getBusinessList();
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MerchantEnquiry.vue?4d9e9b3f